// TODO: can this be removed? where is it used?
export var IN = "_~IN~_";
//# sourceMappingURL=constants.js.map